export const EDUCATION_QUALIFICATION_OPTIONS = [
  { id: 1, label: 'None' },
  { id: 2, label: 'SSLC' },
  { id: 3, label: 'HSC' },
  { id: 4, label: 'Diploma' },
  { id: 5, label: 'ITI' },
  { id: 6, label: 'Graduate' },
  { id: 7, label: 'Post Graduate' },
  { id: 8, label: 'Doctorate' },
] as const;
